const redHeatMap = [
    '#fee5d9',
    '#fcbba1',
    '#fc9272',
    '#fb6a4a',
    '#de2d26',
    '#a50f15',
]

export default [
    '#d9e2f3',
    '#b4c6e7',
    '#8eaadb',
    '#4472c4',
    '#2f5496',
    '#1f3864',
]
export { redHeatMap }
